import { render, staticRenderFns } from "./QueryView.vue?vue&type=template&id=622b88da&scoped=true&"
import script from "./QueryView.vue?vue&type=script&lang=js&"
export * from "./QueryView.vue?vue&type=script&lang=js&"
import style0 from "./QueryView.vue?vue&type=style&index=0&id=622b88da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622b88da",
  null
  
)

export default component.exports